import React from 'react'
import { StyleSheet } from 'react-native';
import Modal from 'modal-enhanced-react-native-web';
 
export default class Overlay extends React.Component {
    render() {
        return <Modal {...this.props}/>
    }
}
 
